export const EWA_DATE_PIPE_DEFAULT_OPTIONS = {
    dateFormat: 'MM/dd/yy h:mma',
    locale: 'en-US',
};

/**
 * The date format to use for the HTML datetime attribute for date values when using <time> and angular DatePipe.
 */
export const htmlDatetimeAttributeDateFormat = 'yyyy-MM-dd';

/**
 * The date format to use for the HTML datetime attribute for time values when using <time> and angular DatePipe.
 */
export const htmlDateTimeAttributeTimeFormat = 'HH:mm:ss';
